angular.module("AccountingBoxApp").component("customerForm", {
  templateUrl: "app/components/customerForm/customerForm.html",
  controller: customerFormController,
  bindings: {
    customer: "=",
    sale: "=",
    onSubmit: "&"
  }
});

function customerFormController(Customer, $scope, $rootScope, Auth) {
  let ctrl = this;
  const emptyArray = []

  $scope.isAdmin = Auth.isAdmin;
  ctrl.$onInit = function() {
    ctrl.currentCompany = $rootScope.currentCompany
    if (ctrl.customer) {
      ctrl.customer.bankAccountNumbers = ctrl.customer.bankAccountNumbers || [];
      if (ctrl.customer.bankAccountNumbers.length === 0) {
        ctrl.addBankAccountNumber();
      }
    }
  };

  ctrl.addBankAccountNumber = function() {
    let bankAccountNumbers = ctrl.customer.bankAccountNumbers;
    bankAccountNumbers.push("");
    ctrl.customer.bankAccountNumbers = _.uniq(bankAccountNumbers);
  };

  ctrl.onSuggestionSelect = function($item, $model, $label) {
    if($item && !ctrl.customer.address?.line1) {
      ctrl.customer.address = $item;
    }
  }

  function filterAddress(input) {
    return input.filter(address => !!address.addressee);
  }

  const filterAddressMemoized = _.memoize(filterAddress, function resolver() {
    return JSON.stringify(arguments);
  });

  ctrl.addressAddresseeSuggestions = function() {
    if(!ctrl.sale?.Attachment?.extractedData?.addresses) return emptyArray
    return filterAddressMemoized(ctrl.sale.Attachment.extractedData.addresses);
  }

  ctrl.addressSuggestions = function() {
    if(!ctrl.sale?.Attachment?.extractedData?.addresses) return emptyArray
    return ctrl.sale.Attachment.extractedData.addresses;
  }

  ctrl.onSuggestionSelectAddress = function($item, $model, $label) {
      ctrl.customer.address = $item;
  }

  ctrl.bankAccountSuggestions = function() {
    if(!ctrl.sale?.Attachment?.extractedData?.bankAccountNumbers) return emptyArray
    return ctrl.sale.Attachment.extractedData.bankAccountNumbers;
  }

  ctrl.companyRegistrationNumberSuggestions = function() {
    if(!ctrl.sale?.Attachment?.extractedData?.companyRegistrationNumbers) return emptyArray
    return ctrl.sale.Attachment.extractedData.companyRegistrationNumbers;
  }

  ctrl.vatIdentificationNumberSuggestions = function() {
    if(!ctrl.sale?.Attachment?.extractedData?.vatIdentificationNumbers) return emptyArray
    return ctrl.sale.Attachment.extractedData.vatIdentificationNumbers;
  }

  ctrl.emailSuggestions = function() {
    if(!ctrl.sale?.Attachment?.extractedData?.emails) return emptyArray
    return ctrl.sale.Attachment.extractedData.emails;
  }

  ctrl.websiteSuggestions = function() {
    if(!ctrl.sale?.Attachment?.extractedData?.websites) return emptyArray
    return ctrl.sale.Attachment.extractedData.websites;
  }

  ctrl.phoneNumberSuggestions = function() {
    if(!ctrl.sale?.Attachment?.extractedData?.phoneNumbers) return emptyArray
    return ctrl.sale.Attachment.extractedData.phoneNumbers;
  }

  ctrl.paymentTermSuggestions = function() {
    if(!ctrl.sale?.Attachment?.extractedData?.paymentTerms) return emptyArray
    return ctrl.sale.Attachment.extractedData.paymentTerms;
  }

  ctrl.onCompanySelect = function(company) {
    company = _.assign(ctrl.customer, company);
    ctrl.customer = new Customer(company);
  };
}
